module.exports = __webpack_public_path__ + "static/media/knit.3230665b.jpg";